/**
 * Types de recettes pour les formulaires Ajouter / Modifier recette
 * value = valeur en base, labelKey = clé de traduction pour l'affichage
 */
export const recipeTypes = [
  { value: "", labelKey: "recipeTypeNotSpecified" },
  { value: "Entrée", labelKey: "recipeTypeStarter" },
  { value: "Plat principal", labelKey: "recipeTypeMain" },
  { value: "Dessert", labelKey: "recipeTypeDessert" },
  { value: "Soupe", labelKey: "recipeTypeSoup" },
  { value: "Salade", labelKey: "recipeTypeSalad" },
  { value: "Boisson", labelKey: "recipeTypeDrink" },
  { value: "Pâtisserie", labelKey: "recipeTypePastry" },
  { value: "Petit-déjeuner", labelKey: "recipeTypeBreakfast" },
  { value: "Accompagnement", labelKey: "recipeTypeSide" },
  { value: "Sauce", labelKey: "recipeTypeSauce" },
  { value: "Confiserie", labelKey: "recipeTypeConfection" },
  { value: "Autre", labelKey: "recipeTypeOther" },
];
